import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {
    closevoid(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`budgetinternal/closevoid/${obj.ibudghdkey}`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetinternal/detail/${obj.ibudghdkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    ibbooked(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetproduksi/ibbooked/${obj.pjxhdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    mstrbudget(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetproduksi/progress/${obj.pjxhdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    line(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'nomor', 'jccostname','DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'customer', 'cust_po', 'status','ibudghdkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/budgetinternal/line${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'nomor', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'customer', 'cust_po', 'status'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                // if (obj.customQuery) {
                //     str += str ? '&' : '?';
                //     str += obj.customQuery;
                // }
                const url = `/budgetinternal${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename );
                const { data } = await axios.post("budgetinternal/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },  
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/budgetinternal/send2wfCancel/${obj.ibudghdkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    progress(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetinternal/progress/${obj.ibudghdkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    progressprint(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.pjxhdrkey) {
                    const url = `/budgetinternal/progressprint/${obj.ibudghdkey}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    progressdtl(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetinternal/progressdtl/${obj.ibudgdtkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    print(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.pjxhdrkey) {
                    const url = `/budgetinternal/print/${obj.ibudghdkey}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'nomor', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'customer', 'cust_po', 'status'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/budgetinternal/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'internalbudgetlist.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },    
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const resp = await axios.post(`/budgetinternal`, obj);
                // resolve(resp);
                const { data } = await axios.post("budgetinternal", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/budgetinternal/${obj.ibudghdkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },

};